import React, { ReactElement, Component, useContext, useEffect, useMemo } from "react";
import { injectIntl } from 'react-intl';
import './workspaces-list.less';
import { WorkspaceContext, workspaces_type_item } from "../../contexts/workspaces";
import { ItemsContext, item } from "../../contexts/items";
// import { left_menu_item, LeftMenuContext, menu_items } from "../../contexts/left-menu";
import { LeftMenuTitleContext } from "../../contexts/left-menu-title";
import { CardSelectableContext } from "../../contexts/card-selectable";
import { SearchTitleContext } from "../../contexts/search-title";
import { http_get, http_request, destroy_worker } from "../../worker/http-func";
import { QuotaContext, quota_type } from "../../contexts/quota-management";
import { IsInTabsContext } from "../../contexts/is-in-tabs";
import TableList from "../../components/table-list/table-list";
import { TableDescContext } from "../../contexts/table-desc";
import { IsFreshContext } from '../../contexts/is_fresh';
import { ClusterSelectedContext } from "../../contexts/cluster-selected";
import { TypeNameContext } from "../../contexts/type_name";
import { ClustersForPageContext } from "../../contexts/clusters-for-page";
import { UserInfoContext, IUserInfoType } from "../../contexts/user-info";
import { clusters_for_page_type } from "../../contexts/clusters-for-page";
import { DatacenternameContext } from "../../contexts/datacenter-name";
import { ClusterContext, clusters_type_item } from "../../contexts/clusters";
import { SortFirstContext } from "../../contexts/sort-first";
import { useDeepCompareMemo } from 'use-deep-compare';

export interface workspace_new {
    name: string;
    selfLink: string;
    resourceVersion: string;
    generation: number;
    creationTimestamp: string;
    quotaName?: string;
    updateTime: string;
    totalNamespaces: string;
    cpu: { usedCPU: string, limitCPU?: string };
    memory: { usedMemory: string, limitMemory?: string };
    rootfs: { usedRootfs: string, limitsRootfs?: string };
    pod: { usedPod: string, limitsPod?: string };
    pvc: { usedDisk: string, limitsDisk?: string };
    gpu: { usedGPU: string; totalGPU?: string };
    labels: object;
    createTime: string;
}

const WorkspacesList: React.FC = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
    const [workspaces, set_workspaces]: [workspaces_type_item[] | undefined, React.Dispatch<React.SetStateAction<workspaces_type_item[] | undefined>>] = useContext(WorkspaceContext),
        user_info: IUserInfoType = useContext(UserInfoContext)[0],
        datacenter_name: string | undefined = useContext(DatacenternameContext)[0],
        set_items: React.Dispatch<React.SetStateAction<item[]>> = useContext(ItemsContext)[1],
        //  set_left_menu_items: React.Dispatch<React.SetStateAction<left_menu_item[]>> = useContext(LeftMenuContext)[1],
        set_left_menu_title: React.Dispatch<React.SetStateAction<string>> = useContext(LeftMenuTitleContext)[1],
        set_card_selectable: React.Dispatch<React.SetStateAction<boolean>> = useContext(CardSelectableContext)[1],
        is_fresh: boolean = useContext(IsFreshContext)[0],
        set_search_title: React.Dispatch<React.SetStateAction<string>> = useContext(SearchTitleContext)[1],
        [quotas, set_quotas]: [quota_type['items'], React.Dispatch<React.SetStateAction<quota_type['items']>>] = useContext(QuotaContext),
        set_is_in_tabs: React.Dispatch<React.SetStateAction<boolean>> = useContext(IsInTabsContext)[1],
        set_table_desc: React.Dispatch<React.SetStateAction<string[]>> = useContext(TableDescContext)[1],
        cluster_selected: item | undefined = useContext(ClusterSelectedContext)[0],
        set_clusters: React.Dispatch<React.SetStateAction<clusters_type_item[]>> = useContext(ClusterContext)[1],
        [type_name, set_type_name]: [string | undefined, React.Dispatch<React.SetStateAction<string | undefined>>] = useContext(TypeNameContext),
        clusters_for_page: clusters_for_page_type | undefined = useContext(ClustersForPageContext)[0],
        sort_first: string = useContext(SortFirstContext)[0],

        { formatMessage }: { formatMessage: any } = useDeepCompareMemo(() => props.intl, [props.intl]),
        is_permitted = useMemo(() => user_info.role === 'globalAdmin' || user_info.role === 'clusterAdmin' || user_info.role === 'clusterOwner', [user_info.role]);

    useEffect(() => () => { destroy_worker() }, []);

    useEffect(() => {
        // 如果state存在的话说明是从concole页面跳转过来，执行set_type_name，否则不执行
        if (props.history.location.state) {
            const type_name_new: string = props.history.location.state?.type;
            set_type_name(type_name_new);
        }
    }, [set_type_name, props.history.location.state])

    useEffect(() => {
        user_info.role !== '' && is_permitted && datacenter_name && http_get('workspaces_page', ['clusters', set_clusters, 'workspacequotas', set_quotas], user_info.role, `${user_info.subscription_id}&type=${type_name}`, datacenter_name, cluster_selected?.name || '');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [set_workspaces, set_quotas, is_fresh, set_clusters, user_info.role]);

    useEffect((): void => {
        if (cluster_selected || (cluster_selected && is_permitted)) {
            const { name }: item = cluster_selected;
            if (user_info.role !== '' && (is_permitted || user_info.role === 'workspaceOwner') && datacenter_name) {
                http_request('workspaces', props, set_workspaces, `/v1/datacenter/${datacenter_name}/cluster/${name}/workspaces`, 0, user_info.role, `${user_info.subscription_id}&type=${type_name}`, datacenter_name, name || '');
                http_request('workspacequotas', props, set_quotas, `/v1/datacenter/${datacenter_name}/cluster/${name}/workspacequotas`, 0, user_info.role, user_info.subscription_id, datacenter_name, name || '');
            } else {
                set_workspaces([]);
                set_quotas([]);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cluster_selected?.name, set_quotas, user_info.role, set_workspaces, type_name]);

    useEffect((): void => {
        if (type_name) {
            const get_length = (type_name_new: string) =>
                ((clusters_for_page || {}) as { [key: string]: clusters_type_item[] | undefined })[`clusters_for_${type_name_new}_namespaces_page`]?.length;
            if (!get_length(type_name)) {
                const type_name_new: string = type_name === 'dedicate' ? 'shared' : 'dedicate';
                get_length(type_name_new) !== undefined && (get_length(type_name_new) ? set_type_name(type_name_new) : props.history.push('/workspace-info/namespaces'));
            }
        } else {
            sessionStorage.getItem('sidebarKey')?.includes('shared') ? set_type_name('shared') : set_type_name('dedicate')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props, type_name, set_type_name, clusters_for_page]);

    useEffect((): void => {
        set_left_menu_title('Cluster');
    }, [set_left_menu_title]);

    useEffect((): void => {
        set_card_selectable(true);
    }, [set_card_selectable]);

    useEffect((): void => {
        set_is_in_tabs(false);
    }, [set_is_in_tabs]);

    useEffect((): void => {
        set_table_desc([`${formatMessage({ id: 'workspaces' })}`, `${formatMessage({ id: 'workspaces_desc' })}`]);
    }, [set_table_desc, formatMessage]);

    useEffect((): void => {
        if (Array.isArray(workspaces)) {
            const workspaces_new: workspace_new[] = workspaces && workspaces.map(
                (workspace: workspaces_type_item) => {
                    const workspace_quota_name = (workspace.spec || {}).workspacequota;
                    // { limitCPU, limitMemory, limitsRootfs, limitsPod, limitsDisk } = ((quotas.find(quota => quota.metadata.name === workspace_quota_name) || {}).metadata || {}) || (quotas[0] || {}).metadata;
                    return (
                        ({
                            name, key, selfLink, resourceVersion, generation, creationTimestamp, usedCPU, usedMemory, usedRootfs, usedPod, usedDisk, usedGPU, requestCPU, limitCPU, requestMemory, limitMemory, totalCPU, totalMemory, totalRootfs, totalPod, totalDisk, totalGPU, totalNamespaces, labels, updateTime, createTime
                        }) => ({
                            name,
                            key,
                            selfLink,
                            resourceVersion,
                            quotaName: workspace_quota_name,
                            generation,
                            creationTimestamp,
                            totalNamespaces,
                            cpu: { usedCPU, requestCPU, limitCPU, totalCPU },
                            memory: { usedMemory, requestMemory, limitMemory, totalMemory },
                            rootfs: { usedRootfs, totalRootfs },
                            pod: { usedPod, totalPod },
                            pvc: { usedDisk, totalDisk },
                            gpu: { usedGPU, totalGPU },
                            status: workspace.status && workspace.status.phase,
                            labels,
                            updateTime,
                            createTime
                        }))(workspace.metadata)

                });
            set_items(sort_first ? workspaces_new.filter((item: item) => (item?.labels?.name === sort_first)).concat(workspaces_new.filter((item: item) => (item?.labels?.name !== sort_first))) : workspaces_new);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [set_items, workspaces, quotas, is_fresh]);

    useEffect(() => {
        set_search_title('workspace');
    }, [set_search_title]);

    return (
        <TableList />
    )
}

export default injectIntl(WorkspacesList);
